<template>
  <!-- Modal of confirm sale -->
  <div
    class="modal fade"
    :id="'saleConfirmWindow_'+lot.id"
    tabindex="-1"
    role="dialog"
    :aria-labelledby="'saleConfirmWindowTitle_'+lot.id"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" :id="'saleConfirmWindowTitle_'+lot.id">{{ trans('lots.confirm_sale_title') }}</h5>
          <button type="button" class="btn-close" data-dismiss="modal" aria-label="Lukk"></button>

        </div>
        <div class="modal-body text-success">
          {{ trans('lots.confirm_sale_text') }}
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-success"
            @click="sale(lot.id)"
            data-dismiss="modal"
          >{{ trans('lots.confirm_sale_yes') }}</button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
          >{{ trans('lots.confirm_sale_no') }}</button>
        </div>
      </div>
    </div>
  </div>
  <component :is="currentTemplate">
    <template v-slot:price>
      {{ new Intl.NumberFormat('ru-RU').format(lot.price) }}
    </template>
    <template v-slot:buttons>
      <div
        v-if="!reserved"
        class="d-flex gap-2 my-2"
        role="group"
        aria-label="Buy form"
      >
        <a
          role="button"
          class="extra-rounded text-center btn-lg btn-success dark-button"
          style="background-color: green"
          data-toggle="modal"
          :data-target="'#saleConfirmWindow_'+lot.id"
        >
          {{ trans('lots.buy_now') }}
        </a>
        <a
          role="button"
          class="extra-rounded text-center btn-lg btn-primary dark-button"
          style="background-color: #b68b29"
          @click="reserve(lot.id)"
          v-if="lot.allow_reserve"
        >
          <span v-if="reserve_time===1">{{ trans('lots.reserve_for_1').replace(':hours', reserve_time) }}</span>
          <span v-else>{{ trans('lots.reserve_for_2').replace(':hours', reserve_time) }}</span>
        </a>
      </div>
      <div v-else-if="reservedItem?.current_user">
        <div
          class="d-flex gap-2 my-2 text-center"
          role="group"
          aria-label="Buy form"
        >
          <a
            role="button"
            class="extra-rounded text-center btn-lg btn-success dark-button"
            style="background-color: green"
            data-toggle="modal"
            :data-target="'#saleConfirmWindow_'+lot.id"
          >
            {{ trans('lots.buy_now') }}
          </a>
          <a
            role="button"
            class="extra-rounded text-center btn-lg btn-primary dark-button"
            style="background-color: #b68b29"
            @click="cancelReserve(lot.id)"
            v-if="lot.allow_reserve"
          >
            {{ trans('lots.cancel_reserve') }}
          </a>
        </div>
        <span class="text-center text-danger d-block"> {{ trans('lots.reserved_until')}} {{ getUntil() }}</span>
      </div>
      <div v-else class="row light-bg extra-rounded my-2 mx-0">
        <div class="col-12 px-0">
            <span class="font-s14 px-2 py-2 d-block text-center text-danger fw-bold-600">
              {{ trans('lots.reserved_until_others')}} {{ getUntil() }}
            </span>
        </div>
      </div>

    </template>
    <template v-slot:error>
      <div v-if="!!error" class="row  mt-2">
        <div class="col-12">
          <div class="alert alert-danger" role="alert">
            {{ error }}
          </div>
        </div>
      </div>
    </template>
  </component>
</template>
<script>
import moment from "moment/moment";
import LotControlPanelTemplate from "./LotControlPanelTemplate.vue";
import LotControlPanelCompactTemplate from "./LotControlPanelCompactTemplate.vue";

const MODE_COMPACT = 'compact'

export default {
  name: "FixPriceControlPanelComponent",
  components: {LotControlPanelTemplate, LotControlPanelCompactTemplate},
  props: {
    lot: {
      required: true
    },
    reserve_time: {
      required: true
    },
    mode: {
      type: String,
      default: ''
    }
  },

  emits: ['sold', 'reserved'],
  created() {
    this.auction_id = this.lot.auction_id
    this.reservedItem = this.lot.reserved
    this.reservedUntil = this.reservedItem?.until;
    this.currentTemplate = this.mode === MODE_COMPACT
      ? 'LotControlPanelCompactTemplate'
      : 'LotControlPanelTemplate'
    ;
  },
  data() {
    return {
      currentTemplate: undefined,
      auction_id: undefined,
      error: undefined,
      reservedItem: undefined,
      reservedUntil: null,
      sold: false,
    }
  },
  computed: {
    reserved() {
      return this.reservedItem
        ? moment(this.reservedItem.until) > moment()
        : false;
    }
  },
  methods: {
    sale(lot_id) {
      if (this.reserved && !this.reservedItem.current_user) {
        return;
      }
      this.error = undefined
      axios.put(`/auctions/${this.auction_id}/lots/ajax/${lot_id}/`,{
        amount: this.lot.price
      })
        .then(() => {
          this.$emit('sold')
          this.sold = true
        }).catch(err => {
          this.error = err.response.data.message
        })
    },
    reserve(lot_id) {
      if (this.reserved) {
        return;
      }
      this.error = undefined
      axios({
        url: `/auctions/${this.auction_id}/lots/ajax/${lot_id}/reserve`,
        method: 'PUT',
        data: {interval: this.reserve_time}
      }).then(resp => {
        this.lot.time_end = resp.data.lot.time_end
        this.reservedItem = resp.data.lot.reserved
        this.reservedUntil = this.reservedItem?.until
      }).catch(err => {
        this.error = err.response.data.message
      })
    },
    cancelReserve(lot_id) {
      if (!this.reserved) {
        return;
      }
      this.error = undefined
      axios.put(`/auctions/${this.auction_id}/lots/ajax/${lot_id}/free_lot`)
        .then(() => {
          this.reservedItem = undefined
          this.reservedUntil = undefined
        }).catch(err => {
          this.error = err.response.data.message
        })
    },
    getUntil() {
      return moment(this.reservedUntil).format('DD.M.Y HH:mm')
    },
  },

}
</script>
<style scoped>
</style>
